// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import api from './provider'
import store from './store';

// permission control
import './permission'; 

/* css */
import animated from 'animate.css'//引入animate.css
import '@/styles/universal.scss' // global css

// import Cookies from 'js-cookie'

// Internationalization
import i18n from './lang';

//svg icon
import './icons'

Vue.config.productionTip = false

import moment from "moment";
Vue.prototype.$moment = moment;

import Message from '@/components/message/message';
Vue.prototype.$message = Message.install;

// global method
import utility from "@/utils/utility";
Vue.prototype.$utility = utility;

Vue.use(api)

/* eslint-disable no-new */
new Vue({
	el:'#app',
	router,
	i18n,
	store,
	components:{ App },
	render:h=>h(App)
})



// WEBPACK FOOTER //
// ./src/main.js